export enum MentalStateSlug {
  ANXIETY = 'anxiety',
  DEPRESSION = 'depression',
  BURNOUT = 'burnout',
  STRESS_RESILIENCE = 'stress_resilience',
  POST_TRAUMATIC_STRESS = 'post_traumatic_stress',
  INSOMNIA = 'insomnia',
  WORK_STRESS = 'work_stress',
}

export enum SymptomSlug {
  INSOMNIA = 'insomnia',
  FATIGUE = 'fatigue',
  INTEREST_LOSS = 'interest_loss',
  DEPRESSED_MOOD = 'depressed_mood',
  APPETITE_CHANGE = 'appetite_change',
  GUILT_FEELINGS = 'guilt_feelings',
  CONCENTRATION_DIFFICULTY = 'concentration_difficulty',
  PSYCHOMOTOR_CHANGE = 'psychomotor_change',
  SUICIDAL_THOUGHTS = 'suicidal_thoughts',
  NERVOUSNESS = 'nervousness',
  UNCONTROLLABLE_WORRY = 'uncontrollable_worry',
  EXCESSIVE_WORRY = 'excessive_worry',
  INABILITY_RELAX = 'inability_relax',
  RESTLESSNESS = 'restlessness',
  IRRITABILITY = 'irritability',
  FEAR = 'fear',
  EMOTIONAL_EXHAUSTION = 'emotional_exhaustion',
  DEPERSONALIZATION = 'depersonalization',
  REDUCED_ACCOMPLISHMENT = 'reduced_accomplishment',
}
